<template>
  <esg-base-dashboard-card title="공급망 평가 상세정보"
                           style="padding : 0;">
    <template #actions>
      <b-col cols="12"
             md="12"
             lg="12">
        <b-row align-h="end">
          <b-form-select v-model="businessLoc"
                         size="sm">
            <option disabled="true"
                    :value="'all'">주거래 사업장
            </option>
            <option :value="'all'">ALL</option>
            <option v-for="option in mainBizLocOptions"
                    :key="option"
                    :value="option">{{ option }}
            </option>
          </b-form-select>
        </b-row>
      </b-col>
    </template>
    <template #default>
      <esg-table-without-meta :fields="fields"
                              :items="getItem"
                              size="sm">
        <template #thead-top>
          <tr>
            <th colspan="3"
                class="text-center"><span>협력사 정보</span></th>
            <th colspan="8"
                class="text-center"><span>평가관리</span></th>
          </tr>
        </template>
        <template #cell(overallAssessment)="row">
          <td>
            <span v-if="row.item.overallAssessment===0 && row.index/2!==0">Leader <b-icon icon="caret-up-fill"
                                                                                          style="color:red; font-family:bold;"/></span>
            <span v-else-if="row.item.overallAssessment===1">Average</span>
            <span v-else>Laggard <b-icon icon="caret-down-fill"
                                         style="color:blue;"/></span>
          </td>
        </template>
        <template #cell(environment)="row">
          <td>
            <span v-if="row.item.environment===0">Leader <b-icon icon="caret-up-fill"
                                                                 style="color:red;"/></span>
            <span v-else-if="row.item.environment===1">Average</span>
            <span v-else>Laggard <b-icon icon="caret-down-fill"
                                         style="color:blue;"/></span>
          </td>
        </template>
        <template #cell(safety)="row">
          <td>
            <span v-if="row.item.safety===0 ">Leader <b-icon icon="caret-up-fill"
                                                             style="color:red;"/></span>
            <span v-else-if="row.item.safety===1">Average</span>
            <span v-else>Laggard <b-icon icon="caret-down-fill"
                                         style="color:blue;"/></span>
          </td>
        </template>
        <template #cell(society)="row">
          <td>
            <span v-if="row.item.society===0 ">Leader </span>
            <span v-else-if="row.item.society===1 && row.index%4!==0">Average <b-icon icon="caret-up-fill"
                                                                                      style="color:red;"/></span>
            <span v-else>Laggard <b-icon icon="caret-down-fill"
                                         style="color:blue;"/></span>
          </td>
        </template>
        <template #cell(ethic)="row">
          <td>
          <span v-if="row.item.ethic===0">Leader <b-icon icon="caret-up-fill"
                                                         style="color:red;"/></span>
            <span v-else-if="row.item.ethic===1&& row.index/2!==0">Average <b-icon icon="caret-down-fill"
                                                                                   style="color:blue;"/></span>
            <span v-else>Laggard</span>
          </td>
        </template>
        <template #cell(economy)="row">
          <td>
            <span v-if="row.item.economy===0">Leader</span>
            <span v-else-if="row.item.economy===1 && row.index%3!==0">Average <b-icon icon="caret-up-fill"
                                                                                      style="color:red;"/></span>
            <span v-else>Laggard <b-icon icon="caret-down-fill"
                                         style="color:blue;"/></span>
          </td>
        </template>
        <template #cell(managementSystem)="row">
          <td>
          <span v-if="row.item.managementSystem!==1 && row.index%2===0">Leader<b-icon icon="caret-up-fill"
                                                                                      style="color:red;"/></span>
            <span v-else-if="row.item.managementSystem===0">Average</span>
            <span v-else>Laggard <b-icon icon="caret-down-fill"
                                         style="color:blue;"/></span>
          </td>
        </template>
        <template #cell(file)="data">
          <td class="text-center">
            <img v-if="data.item.file !== ''"
                 class="fit-picture"
                 src="@/components/esg/images/excel.png"
                 alt="Grapefruit slice atop a pile of other slices"
                 style="height:1.5em;"/>
          </td>
        </template>
      </esg-table-without-meta>
    </template>
  </esg-base-dashboard-card>
</template>
<script>
import EsgBaseDashboardCard from "@/components/esg/base/EsgBaseDashboardCard.vue";
import EsgTableWithoutMeta from "@/components/esg/base/EsgTableWithoutMeta.vue";

export default {
  props: ['gridId'],
  components: {EsgTableWithoutMeta, EsgBaseDashboardCard},
  methods: {
    getLabel(param) {

      switch (param) {
        case 0:
          param = 'Leader'
          break;
        case 1:
          param = 'Leader'
          break;
        case 2:
          param = 'Leader'
          break;
      }
      return param
    }
  },
  mounted() {

    this.$refs.table.render();

  },
  data() {
    return {
      businessLoc: 'all',
      status: 'all',
      loading: false,
      items: [
        [
          {
            id: "2022-001",
            corpName: "EY 컨설팅",
            businessLocation: "울산 고무공장",
            overallAssessment: 0,
            environment: 1,
            safety: 1,
            society: 1,
            ethic: 2,
            economy: 1,
            managementSystem: 2,
            file: 'test'
          },
          {
            id: "2022-002",
            corpName: "EY 한영",
            businessLocation: "당진 고무공장",
            overallAssessment: 0,
            environment: 1,
            safety: 1,
            society: 1,
            ethic: 2,
            economy: 1,
            managementSystem: 2,
            file: 'test'
          },
          {
            id: "2022-003",
            corpName: "EY 세무",
            businessLocation: "울산 고무공장",
            overallAssessment: 0,
            environment: 1,
            safety: 1,
            society: 1,
            ethic: 2,
            economy: 1,
            managementSystem: 2,
            file: 'test'
          },
          {
            id: "2022-004",
            corpName: "EY KDS",
            businessLocation: "당진 고무공장",
            overallAssessment: 0,
            environment: 1,
            safety: 1,
            society: 1,
            ethic: 2,
            economy: 1,
            managementSystem: 2,
            file: 'test'
          },
          {
            id: "2022-005",
            corpName: "EY  정공",
            businessLocation: "당진 고무공장",
            overallAssessment: 1,
            environment: 0,
            safety: 1,
            society: 1,
            ethic: 2,
            economy: 1,
            managementSystem: 2,
            file: 'test'
          },
          {
            id: "2022-006",
            corpName: "EY 운송",
            businessLocation: "당진 고무공장",
            overallAssessment: 2,
            environment: 1,
            safety: 1,
            society: 1,
            ethic: 2,
            economy: 1,
            managementSystem: 2,
            file: 'test'
          },
          {
            id: "2022-007",
            corpName: "EY GDS",
            businessLocation: "당진 고무공장",
            overallAssessment: 1,
            environment: 1,
            safety: 2,
            society: 1,
            ethic: 0,
            economy: 1,
            managementSystem: 2,
            file: 'test'
          }
        ],
      ],
    }
  },
  created() {
  },
  computed: {
    mainBizLocOptions() {
      return new Set(this.items[0].map(obj => obj.businessLocation));
    },
    getItem() {
      return this.items[this.gridId];
    },
    fields() {
      let fieldSet = [];
      switch (this.gridId) {
        case 0:
          fieldSet = [
            {
              name: "id",
              label: "관리번호",
              list: true,
              thClass: ["text-center"],
              tdClass: ["text-center", "align-middle"],
              sortable: true
            },
            {
              name: "corpName",
              label: "협력사 명",
              list: true,
              thClass: ["text-center"],
              tdClass: ["text-center", "align-middle"],
              sortable: true
            },
            {
              name: "businessLocation",
              label: "주거래 사업장",
              list: true,
              thClass: ["text-center"],
              tdClass: ["text-center", "align-middle"],
              sortable: true
            },
            {
              name: "overallAssessment",
              label: "종합평가",
              list: true,
              thClass: ["text-center"],
              tdClass: ["text-center", "align-middle"],
              sortable: true,
              variant: 'warning'
            },
            {
              name: "environment",
              label: "E(환경)",
              list: true,
              thClass: ["text-center"],
              tdClass: ["text-center", "align-middle"],
              sortable: true
            },
            {
              name: "safety",
              label: "S(안전)",
              list: true,
              thClass: ["text-center"],
              tdClass: ["text-center", "align-middle"],
              sortable: true
            },
            {
              name: "society",
              label: "S(사회)",
              list: true,
              thClass: ["text-center"],
              tdClass: ["text-center", "align-middle"],
              sortable: true
            },
            {
              name: "ethic",
              label: "S(윤리)",
              list: true,
              thClass: ["text-center"],
              tdClass: ["text-center", "align-middle"],
              sortable: true
            },
            {
              name: "economy",
              label: "G(경제)",
              list: true,
              thClass: ["text-center"],
              tdClass: ["text-center", "align-middle"],
              sortable: true
            },
            {
              name: "managementSystem",
              label: "G(경영시스템)",
              list: true,
              thClass: ["text-center"],
              tdClass: ["text-center", "align-middle"],
              sortable: true
            },
            {
              name: "file",
              label: "파일",
              list: true,
              thClass: ["text-center"],
              tdClass: ["text-center", "align-middle"]
            }
          ]
          break;
      }
      return fieldSet;
    }
  },
}
</script>
<style>
#EsgPartnerCorpMonitoringProgressManagementGrid .b-table-sticky-header > .table.b-table > thead > tr > th {
  text-align: center;
  border: 1px solid white;
  border-collapse: collapse;
}

#EsgPartnerCorpMonitoringProgressManagementGrid .card .card-body {
  padding: 0;
}

#EsgPartnerAssessmentMgmtGrid .table thead {
  background-color: #E9ECEF !important;
}
</style>